import './Button.scss';
import IconButton from "@mui/material/IconButton";
import { Link } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { BACK_NAVIGATION_TYPE } from "../../../helpers/constants";

const BackButton = ({ className, backButtonPath, removeItemsFromCustomHistory, backButton, backButtonClickFn }) => {

  return (
    <IconButton
      className={className}
      aria-label="Go back"
      component={(backButtonPath && backButtonPath !== BACK_NAVIGATION_TYPE) ? Link : "button"}
      to={(backButtonPath && backButtonPath !== BACK_NAVIGATION_TYPE) ? backButtonPath : undefined}
      onClick={(e) => {
        if (!backButtonPath || backButtonPath === BACK_NAVIGATION_TYPE) {
          e.preventDefault();
          removeItemsFromCustomHistory(-1);
          window.history.back();
          backButtonClickFn?.();
        } else {
          removeItemsFromCustomHistory(backButtonPath);
          backButtonClickFn?.();
        }
      }}
      ref={backButton}
    >
      <ArrowBackIcon className="back-button-icon" />
    </IconButton>
  );
};

export default BackButton;